import { Component, Input, Output, EventEmitter } from "@angular/core";
import { BaseComponent } from "../../../base.component";
import {
  Form,
  FormControl,
  FormGroup,
  FormArray,
  Validators,
  ValidatorFn,
} from "@angular/forms";

import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { customEmailFormValidator } from "../../../_helpers/customEmailFormValidator";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";
import { autoFillForms } from "../../../_helpers/auto-fill-forms/auto-fill-forms";

@Component({
  moduleId: module.id,
  selector: "free-pay",
  templateUrl: "free-pay.component.html",
  styleUrls: ["../cash/cash.component.css", "./free-pay.component.scss"],
})
export class FreePayComponent extends BaseComponent {
  @Input() public amount: number = 0;
  @Output() public actionCompleted?: EventEmitter<void> =
    new EventEmitter<void>();
  public errorMessage: string;
  public loading: boolean = false;
  public successMessage: string;

  public formGroupObj: FormGroup;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
    autoFillForms(this, { shouldSubmit: false });
  }

  public run() {
    this.formGroupObj = new FormGroup({
      firstName: new FormControl(null, Validators.required),
      lastName: new FormControl(null, Validators.required),
      email: new FormControl(null, [
        Validators.required,
        Validators.email,
        customEmailFormValidator(),
      ]),
      phone: new FormControl(null, this.validatePhone),
    });
  }

  public validatePhone(c: FormControl) {
    let PHONE_REGEXP =
      /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    return !c.value || PHONE_REGEXP.test(c.value)
      ? null
      : {
          validatePhone: {
            valid: false,
          },
        };
  }

  public submit() {
    if (!this.loading) {
      this.errorMessage = undefined;

      this.loading = true;
      this.dataService
        .postEntity("checkout-without-paying", {
          ...this.formGroupObj.getRawValue(),
          payments: [
            {
              isCash: true,
              amount: 0,
              chequeDate: null,
              chequeNumber: null,
            },
          ],
        })
        .subscribe(
          (data) => {
            this.loading = false;
            this.successMessage = "ההרשמה בוצעה בהצלחה.";
          },
          (error) => {
            this.loading = false;
            let body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.base.messages[body.statusText]
                  ? this.base.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/free-pay/free-pay.component.ts